import { ReactNode } from 'react';

type PageShellProps = {
  children: ReactNode;
  variant?: 'default' | 'form' | 'dashboard';
  className?: string;
};

export function PageShell({ children, variant = 'default', className = '' }: PageShellProps) {
  const base =
    variant === 'form'
      ? 'erp-page erp-page--form'
      : variant === 'dashboard'
        ? 'erp-page--dashboard'
        : 'erp-page';
  return <div className={`${base} ${className}`.trim()}>{children}</div>;
}
